import React from "react";

const STATUS_COLORS = {
  HEALTHY: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  WARNING: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  CRITICAL: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  UNKNOWN: "bg-slate-500/15 text-slate-300 border-slate-500/30",
};

const SEV_COLORS = {
  CRITICAL: "bg-rose-500/15 text-rose-300 border-rose-500/40",
  WARNING: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  INFO: "bg-sky-500/15 text-sky-300 border-sky-500/40",
};

export function HealthBadge({ status, size = "md" }) {
  const s = String(status || "UNKNOWN").toUpperCase();
  const cls = STATUS_COLORS[s] || STATUS_COLORS.UNKNOWN;
  const sz = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span className={`inline-flex items-center rounded-full border font-black uppercase tracking-wider ${sz} ${cls}`}
      data-testid={`mon-status-${s.toLowerCase()}`}>{s}</span>
  );
}

export function SeverityBadge({ severity }) {
  const s = String(severity || "INFO").toUpperCase();
  const cls = SEV_COLORS[s] || SEV_COLORS.INFO;
  return (
    <span className={`inline-flex items-center rounded-full border font-black uppercase tracking-wider text-[10px] px-2 py-0.5 ${cls}`}
      data-testid={`mon-sev-${s.toLowerCase()}`}>{s}</span>
  );
}

/** Circular health-score ring 0-100. Green>=90, Yellow>=70, Red<70. */
export function HealthScoreRing({ value = 0, size = 84, stroke = 8, testid = "mon-score-ring" }) {
  const v = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (v / 100) * c;
  const color = v >= 90 ? "#10B981" : v >= 70 ? "#F59E0B" : "#EF4444";
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid={testid}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} strokeWidth={stroke} fill="none" stroke="rgba(255,255,255,0.08)" />
        <circle cx={size / 2} cy={size / 2} r={r} strokeWidth={stroke} fill="none" stroke={color}
          strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 500ms ease" }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center leading-none">
        <div className="text-lg font-black font-display text-white" data-testid={`${testid}-value`}>{v}</div>
        <div className="text-[9px] uppercase tracking-widest text-white/40 mt-0.5">score</div>
      </div>
    </div>
  );
}
